/**
 * @Description 列表
 */

import { FC, ReactNode } from 'react';
import V2Table from '@/common/components/Data/V2Table';
import { ButtonProps } from 'antd';
import styles from '../index.module.less';
interface TableProps {
  onRefresh?: (value: any) => void
  selectedRowKeys?: any[];
  tableData?: any[];
  setSelectedRowKeys?: (value: any) => void;
  onAction?: (key: string, recoder: any) => void;
  message?: ReactNode;
  onSortOrderChange?: (value: any) => void;
  refreshCurrent?: boolean; // 当前页刷新
  rowSelection?: any;
  onFetch?: () => void;
  filters?: any;
  rowSelectionOperate?: Array<{
    text: string,
    onClick: any,
    icon?: any,
    btnConfig?: ButtonProps
  }>;
  /**
   * @description 从1页重新加载
   */
  reload?: () => void;
  /**
   * @description 从当前页重新加载
   */
   currentReload?: () => void;

   modColumn?: any;

   [key: string]:any;
}

const TableList: FC<TableProps> = ({
  onFetch,
  filters,
  refreshCurrent,
  modColumn,
  ...props
}) => {

  const columns:any = [
    {
      key: 'name',
      title: '名称',
      dragChecked: true,
      importWidth: true,
      width: 223,
    },
    {
      key: modColumn?.value,
      title: modColumn?.label,
      dragChecked: true,
      importWidth: true,
      winth: 227,
    },
    // {
    //   key: 'distance',
    //   title: `距离`,
    //   dragChecked: true,
    //   width: 72,
    //   forceTooltipRender(_: string) {
    //     return _ ? (_ + 'm') : '-';
    //   },
    //   render(_: string) {
    //     return _ ? (_ + 'm') : '-';
    //   }
    // },
  ];
  modColumn.value === 'liveNum' &&
  columns.splice(1, 0, {
    key: 'houseHolds',
    title: `户数`,
    dragChecked: true,
    importWidth: true,
    minWidth: 227,
  });

  return (
    <>
      <V2Table
        key={modColumn?.value}
        pageSize={10}
        paginationConfig={{
          simple: true,
        }}
        className={styles['table-list']}
        rowKey='name'
        filters={filters}
        scroll={{ x: '100%' }}
        defaultColumns={columns}
        onFetch={onFetch}
        refreshCurrent={refreshCurrent}
        voluntarilyEmpty
        hideColumnPlaceholder
        {...props}
      />
    </>
  );
};

export default TableList;
